<div>
    <vb-panel-header title="My offers"></vb-panel-header>
    <vb-paginator-bar
        *ngIf="!isLoading && userOffers.length > 0"
        variant="top"
        label="offers"
        [dense]="isMobile"
        [current]="paginate.currentPage ?? 1"
        [total]="paginate.totalPages ?? 0"
        [totalItems]="paginate.totalItems ?? 0"
        [perPage]="pageSize"
        [perPageOptions]="pageSizeOptions"
        (pageChange)="setPage($event)"
        (perPageChange)="setPageSize($event)">
    </vb-paginator-bar>
    <div class="table-responsive mt-2 table-container">
        <div *ngIf="!isMobile" class="messages-grid">
            <table class="table" *ngIf="!isLoading && userOffers.length > 0">
                <thead>
                    <tr>
                        <th>
                            <span>Lot No.</span>
                        </th>
                        <th></th>
                        <th>
                            <span>Lot Title</span>
                        </th>
                        <th>
                            <span>Quantity</span>
                        </th>
                        <th>
                            <span>Offer Date</span>
                        </th>
                        <!--Commenting unit price and counter columns for now until we receive the data from BE-->
                        <!-- <th class="text-end">
                            <span>Unit Price</span>
                        </th> -->
                        <th class="text-end">
                            <span>Offer</span>
                        </th>
                        <!-- <th class="text-end">
                            <span>Counter</span>
                        </th> -->
                        <th class="pe-4"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let offer of userOffers; let i = index"
                        [ngClass]="getOfferStatusClass(offer.status)">
                        <td [ngClass]="getOfferStatusClass(offer.status)">
                            {{ offer.lotNo }}
                        </td>

                        <td [ngClass]="getOfferStatusClass(offer.status)">
                            <div class="image-container" *ngIf="offer.thumbnailUrl">
                                <img
                                    *ngIf="offer.thumbnailUrl"
                                    class="img-fluid image-responsive lot-thumbnail"
                                    [src]="offer.thumbnailUrl"
                                    [alt]="'Thumbnail ' + i"
                                    (mouseover)="showLargeImage(i)"
                                    (blur)="hideLargeImage()"
                                    (focus)="showLargeImage(i)"
                                    (mouseout)="hideLargeImage()" />
                                <div
                                    class="large-image"
                                    *ngIf="currentImageIndex === i">
                                    <img
                                        [src]="offer.thumbnailUrl"
                                        [alt]="'Large Image ' + i" />
                                </div>
                            </div>
                            <div
                                class="image-container"
                                *ngIf="!offer.thumbnailUrl">
                                <img
                                    class="img-fluid image-responsive lot-thumbnail"
                                    src="../../../../../../assets/img/brand/no-image-lot.svg"
                                    [alt]="'Thumbnail ' + i"
                                    (mouseover)="showLargeImage(i)"
                                    (mouseout)="hideLargeImage()"
                                    (blur)="hideLargeImage()"
                                    (focus)="showLargeImage(i)" />
                                <div
                                    class="large-image"
                                    *ngIf="currentImageIndex === i">
                                    <img
                                        src="../../../../../../assets/img/brand/no-image-lot.svg"
                                        [alt]="'Large Image ' + i" />
                                </div>
                            </div>
                        </td>

                        <td
                            [ngClass]="getOfferStatusClass(offer.status)"
                            data-bs-toggle="tooltip"
                            title=" {{ offer.title }}"
                            class="cell-wrap">
                            <a
                                routerLink="/auctions/{{ offer.auctionId }}/lot/{{
                                    offer.lotId
                                }}"
                                [queryParams]="
                                    offer.isAdmin
                                        ? {
                                            makeAnOffer: true,
                                            offerId: offer.id
                                        }
                                        : {}
                                "
                                ><u>{{ limitTitleChars(offer.title) }}</u></a
                            >
                        </td>

                        <td [ngClass]="getOfferStatusClass(offer.status)">
                            {{ offer.quantity }}
                        </td>

                        <td [ngClass]="getOfferStatusClass(offer.status)">
                            {{ offer.createdOn | vbDate }}
                        </td>

                        <!-- <td
                            [ngClass]="getOfferStatusClass(offer.status)"
                            class="text-end pe-4">
                            ${{ offer.unitPrice ?? 0 | number: "1.2-2" }}
                        </td> -->

                        <td
                            [ngClass]="getOfferStatusClass(offer.status)"
                            class="text-end pe-4">
                            ${{ offer.price | number: "1.2-2" }}
                        </td>

                        <!-- <td
                            [ngClass]="getOfferStatusClass(offer.status)"
                            class="text-end pe-4">
                            ${{ offer.price | number: "1.2-2" }}
                        </td> -->

                        <td
                            class="pe-4"
                            [ngClass]="getOfferStatusClass(offer.status)">
                            <i
                                class="fa-regular fa-message-lines"
                                data-bs-toggle="tooltip"
                                data-bs-tooltip-inner=""
                                title="Last Message: {{ offer.message }}"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="isMobile && !isLoading && userOffers.length > 0" class="messages-list">
            <ng-container *ngFor="let offer of userOffers; let i = index">
                <article class="message-card" role="listitem" [ngClass]="getOfferStatusClass(offer.status)" >
                <div class="card-main" (click)="navigateToOfferDetails(offer)" role="button" tabindex="0" (keyup.enter)="navigateToOfferDetails(offer)">
                    <div class="card-title">
                            <span >
                                Lot Title: {{ offer.title | slice: 0 : 40 }}
                            </span></div>
                    <div class="card-meta">
                    <span class="date">Offer Price : ${{ offer.price| number: "1.2-2"}}</span>
                    <br/>
                    <span class="location"> Quantity: {{ offer.quantity }}</span>
                    </div>
                </div>
                <details class="card-details">
                    <summary>More</summary>
                    <div class="details-body">
                    <p class="p-0 m-0">Lot Number: {{ offer.lotNo }}</div>
                    <p class="p-0 m-0">Offer Date: {{ offer.createdOn | vbDate }}</p>
                    <p class="p-0 m-0">Message: {{ offer.message | slice: 0 : 40 }}</p>
                </details>
                </article>
            </ng-container>
        </div>
        <div
            *ngIf="!isLoading && userOffers && userOffers.length === 0"
            class="text-center no-data-text">
            <h3 class="fw-normal">No data to show at the moment.</h3>
        </div>

        <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
            <vb-spinner size="xl" label="Loading offers"></vb-spinner>
        </div>
    </div>
    <!-- Footer: status legend left, bare pager right (per-page lives in the
         top bar), mirroring the My-bidding panel. -->
    <div
        class="d-flex mt-3 align-items-center justify-content-between flex-wrap">
        <div class="d-flex">
            <div class="background-accepted bottom-strip"></div>
            <span class="ms-3">Accepted</span>
            <div class="background-rejected bottom-strip ms-4"></div>
            <span class="ms-3">Rejected</span>
            <div class="background-pending bottom-strip ms-4"></div>
            <span class="ms-3">Pending</span>
        </div>
        <vb-paginator
            *ngIf="!isLoading && userOffers.length > 0"
            [current]="paginate.currentPage ?? 1"
            [total]="paginate.totalPages ?? 0"
            [labels]="false"
            [dense]="isMobile"
            (pageChange)="setPage($event)">
        </vb-paginator>
    </div>
</div>
